module.exports = __webpack_public_path__ + "static/CookiesChef_part3_50_05-a2dc795d5e74575ade85c3d7becdbd2a.mp3";